import styled from 'styled-components'
import { Tokens } from '@/assets/tokens'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`

export const Label = styled.label`
  font-size: 14px;
  font-weight: 600;
  color: ${Tokens.ColorTextPrimary};
`

export const LabelRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
  cursor: default;
`

export const InputRow = styled.div`
  display: flex;
  align-items: stretch;
  gap: 8px;
  width: 100%;
`

export const TextInput = styled.input`
  flex: 1;
  min-width: 150px;
  height: 32px;
  padding: 0 8px;
  border: 1px solid ${Tokens.ColorBorder};
  border-radius: ${Tokens.RadiusInput};
  font-size: 14px;
  font-family: inherit;
  background-color: ${Tokens.ColorWhite};
  transition: border-color 0.3s ease;

  &:focus {
    outline: none;
    border-color: ${Tokens.ColorUIPrimary};
  }

  &::placeholder {
    color: ${Tokens.ColorTextPrimary};
    font-size: 14px;
  }

  &:disabled {
    background-color: ${Tokens.ColorBackground};
    color: ${Tokens.ColorTextPrimary};
    cursor: not-allowed;
  }
`

export const AddButton = styled.button`
  height: 32px;
  padding: 0 12px;
  background-color: ${Tokens.ColorUIPrimary};
  color: ${Tokens.ColorWhite};
  border: none;
  border-radius: ${Tokens.RadiusInput};
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s ease;
  white-space: nowrap;

  &:hover:not(:disabled) {
    background-color: ${Tokens.ColorUIPrimaryDim};
  }

  &:disabled {
    background-color: ${Tokens.ColorBorder};
    cursor: not-allowed;
  }
`

export const TagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  padding: 8px;
  min-height: 36px;
  background-color: ${Tokens.ColorWhite};
  border: 1px solid ${Tokens.ColorBorder};
  border-radius: ${Tokens.RadiusInput};
  align-items: flex-start;
  align-content: flex-start;
`

export const TagItem = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  background-color: ${Tokens.ColorUIPrimaryLight};
  color: ${Tokens.ColorTextPrimary};
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s ease;
  position: relative;

  &:hover {
    background-color: ${Tokens.ColorUIDangerDim};
    color: ${Tokens.ColorWhite};
  }
`

export const TagText = styled.span`
  max-width: 100%;
  font-weight: 500;
  color: ${Tokens.ColorTextPrimary};
`

export const RemoveButton = styled.button`
  all: unset;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: ${Tokens.ColorUIDanger};
  }
`

export const EmptyState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 20px;
  color: ${Tokens.ColorTextPrimary};
  font-size: 14px;
  font-style: italic;
`

export const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 2px;
`

export const ClearAllButton = styled.button`
  background: none;
  border: none;
  color: ${Tokens.ColorUIPrimary};
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  text-decoration: underline;
`
